export const systemLocationKeys = {
	all: ['SYSTEM_LOCATIONS'] as const,
	systemLocationCourts: (moduleFor: string, moduleUuid: string, locationId: string) =>
		[...systemLocationKeys.all, 'COURTS', moduleFor, moduleUuid, locationId] as const
};
